import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FauxDropdownWithInlineUiComponent } from 'src/modules/faux-dropdown-with-inline-ui/faux-dropdown-with-inline-ui.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FauxDropdownWithInlineUiComponent,
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    FauxDropdownWithInlineUiComponent
  ]
})
export class FauxDropdownWithInlineUiModule { }
